import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgOpenBook = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="m4.226 13.953 5.428 1.21a1.601 1.601 0 0 0 .693-.001l5.428-1.21a.802.802 0 0 0 .625-.784V4.987A.985.985 0 0 0 15.417 4h-.027c-.072 0-.325.042-5.39.828C4.927 4.041 4.685 4 4.61 4h-.028a.985.985 0 0 0-.982.987v8.18c0 .378.26.703.626.786ZM10.4 5.578s4.885-.76 5.015-.777c.088 0 .185.072.185.188v8.183l-5.2 1.158V5.577Zm-6-.589c0-.066.03-.11.055-.134a.196.196 0 0 1 .132-.054c.133.018 5.013.776 5.013.776v8.753l-5.2-1.162V4.989ZM17.6 4.8a.4.4 0 0 0-.4.4v8.39c0 .572-.407 1.067-.968 1.177L10 15.993l-6.233-1.225A1.204 1.204 0 0 1 2.8 13.59V5.2a.4.4 0 1 0-.8 0v8.39c0 .953.679 1.778 1.614 1.963l6.308 1.239c.025.005.03.008.078.008.047 0 .052-.002.077-.007l6.31-1.24A2.004 2.004 0 0 0 18 13.59V5.2a.4.4 0 0 0-.4-.4Z"
      />
    </svg>
  );
};
export default SvgOpenBook;
